import React, { useState } from "react";
import styled, { useTheme } from "styled-components";
import { HeroSection } from "features/whop/whopLanding/components/HeroSection.tsx";
import { RoleToggle } from "features/whop/whopLanding/components/RoleToggle.tsx";
import { BenefitsSection } from "features/whop/whopLanding/components/BenefitsSection.tsx";
import { MessageSection } from "features/whop/whopLanding/components/MessageSection.tsx";
import { FinalCTA } from "features/whop/whopLanding/components/FinalCTA.tsx";
import { DemoFormSection } from "features/whop/whopLanding/components/DemoFormSection.tsx";
import NewLookWhopLanding from "features/whop/whopLanding/NewLook/NewLookWhopLanding.tsx";

const WhopLandingPage: React.FC = () => {
  const [role, setRole] = useState<Role>("member");
  const { isNewLook } = useTheme();

  if (isNewLook) return <NewLookWhopLanding role={role} setRole={setRole} />;

  return (
    <PageWrapper>
      <HeroSection role={role} />
      <RoleToggle role={role} onRoleChange={setRole} />
      <BenefitsSection role={role} />
      {role === "admin" && <DemoFormSection />}
      <MessageSection role={role} />
      <FinalCTA role={role} />
    </PageWrapper>
  );
};
export default WhopLandingPage;

export type Role = "member" | "admin";

const PageWrapper = styled.div`
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  background: ${(p) => (p.theme.isDarkMode ? "#0a0a0a" : "#ffffff")};
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  /* Ensure sections with their own backgrounds render correctly */
  isolation: isolate;
`;
